module.exports = __webpack_public_path__ + "bf2532df/img/emptyProject.6e9a5987.png";